import { Col, Row, Form } from "@themesberg/react-bootstrap";

const SocialLinksInput = ({ localPropertyData, setlocalPropertyData }) => {
	const handleInputChange = (e) => {
		//console.log(e);
		if (!e.target.name) return;

		let dataType = e.target?.dataset?.type;
		let dataIndex = e.target?.dataset?.index;
		let socialsData = localPropertyData?.["socials"];
		let externalLinksData = localPropertyData?.["external_links"];

		if (dataType === "socials-name") {
			socialsData[dataIndex] = { ...(socialsData?.[dataIndex] ?? []), name: e.target.value };
			setlocalPropertyData({ ...localPropertyData, socials: [...socialsData] });
		} else if (dataType === "socials-link") {
			socialsData[dataIndex] = { ...(socialsData?.[dataIndex] ?? []), link: e.target.value };
			setlocalPropertyData({ ...localPropertyData, socials: [...socialsData] });
		} else if (dataType === "externals-name") {
			externalLinksData[dataIndex] = {
				...(externalLinksData?.[dataIndex] ?? []),
				name: e.target.value,
			};
			setlocalPropertyData({
				...localPropertyData,
				external_links: [...externalLinksData],
			});
		} else if (dataType === "externals-link") {
			externalLinksData[dataIndex] = {
				...(externalLinksData?.[dataIndex] ?? []),
				link: e.target.value,
			};
			setlocalPropertyData({
				...localPropertyData,
				external_links: [...externalLinksData],
			});
		} else if (dataType === "externals-price") {
			externalLinksData[dataIndex] = {
				...(externalLinksData?.[dataIndex] ?? []),
				price: Number(e.target.value),
			};
			setlocalPropertyData({
				...localPropertyData,
				external_links: [...externalLinksData],
			});
		}
	};

	return (
		<div className="px-5">
			{/* <center>
				<h5 className="mb-4">Social links</h5>
			</center>

			{[...Array(4).keys()].map((index) => (
				<Row key={"social-" + index}>
					<Col md={4} className="mb-3">
						<Form.Group id={"propertySocialName" + index}>
							<Form.Label>Name:</Form.Label>
							<Form.Control
								required
								type="text"
								name={"socials-name-" + index}
								data-index={index}
								data-type="socials-name"
								value={localPropertyData?.["socials"]?.[index]?.["name"] ?? ""}
								onChange={(e) => handleInputChange(e)}
								placeholder={index === 0 ? "Facebook" : "Enter name"}
							/>
						</Form.Group>
					</Col>

					<Col md={8} className="mb-3">
						<Form.Group id={"propertySocialLink" + index}>
							<Form.Label>URL:</Form.Label>
							<Form.Control
								required
								type="text"
								name={"socials-link-" + index}
								data-index={index}
								data-type="socials-link"
								value={localPropertyData?.["socials"]?.[index]?.["link"] ?? ""}
								onChange={(e) => handleInputChange(e)}
								placeholder={
									index === 0 ? "https://facebook.com/ajkerroom" : "Enter URL"
								}
							/>
						</Form.Group>
					</Col>
				</Row>
			))} */}

			<center>
				<h5 className="mt-3 mb-4">Booking links</h5>
			</center>

			{[...Array(4).keys()].map((index) => (
				<Row key={"external-" + index}>
					<Col md={3} className="mb-3">
						<Form.Group id={"propertyExternalName" + index}>
							<Form.Label>Name:</Form.Label>
							<Form.Control
								required
								type="text"
								name={"external_links-name-" + index}
								data-index={index}
								data-type="externals-name"
								value={localPropertyData?.["external_links"]?.[index]?.["name"] ?? ""}
								onChange={(e) => handleInputChange(e)}
								placeholder={index === 0 ? "Booking.com" : "Enter name"}
							/>
						</Form.Group>
					</Col>

					<Col md={6} className="mb-3">
						<Form.Group id={"propertyExternalLink" + index}>
							<Form.Label>URL:</Form.Label>
							<Form.Control
								required
								type="text"
								name={"external_links-link-" + index}
								data-index={index}
								data-type="externals-link"
								onChange={(e) => handleInputChange(e)}
								value={localPropertyData?.["external_links"]?.[index]?.["link"] ?? ""}
								placeholder={
									index === 0
										? "http://www.tromp.com/aut-ipsa-quo-libero.html"
										: "Enter URL"
								}
							/>
						</Form.Group>
					</Col>
					<Col md={3} className="mb-3">
						<Form.Group id={"propertyExternalLinkPrice" + index}>
							<Form.Label>Price:</Form.Label>
							<Form.Control
								required
								type="number"
								name={"external_links-price-" + index}
								data-index={index}
								data-type="externals-price"
								value={localPropertyData?.["external_links"]?.[index]?.["price"] ?? ""}
								onChange={(e) => handleInputChange(e)}
								placeholder={0}
							/>
						</Form.Group>
					</Col>
				</Row>
			))}
		</div>
	);
};

export default SocialLinksInput;
